import { render, staticRenderFns } from "./ProfileManagerStaffForm.vue?vue&type=template&id=03821772"
import script from "./ProfileManagerStaffForm.vue?vue&type=script&lang=js"
export * from "./ProfileManagerStaffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports